import React from 'react';
import PopoverProvider from './PopoverProvider';
import PopoverContent from './PopoverContent';
export default class Popover extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            hiding: false,
            visible: this.props.visible,
        };
        this.popoverContent = { layout: () => false };
        this.handleFinishedHiding = () => {
            this.setState({ hiding: false });
        };
        this.setPopoverContentRef = popoverContent => {
            this.popoverContent = popoverContent;
        };
        this.layout = () => {
            this.popoverContent && this.popoverContent.layout();
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.visible && !props.visible) {
            return { ...state, visible: props.visible, hiding: true };
        }
        return null;
    }
    renderPopover() {
        const { children, onClose, anchorId, contentWrapperClassName, position, offsetTop, isCloseButton, isHoverPopover, hasLockedPosition, } = this.props;
        const { hiding } = this.state;
        return (<PopoverContent ref={this.setPopoverContentRef} anchorId={anchorId} contentWrapperClassName={contentWrapperClassName} hasLockedPosition={hasLockedPosition} hiding={hiding} isCloseButton={isCloseButton} isHoverPopover={isHoverPopover} offsetTop={offsetTop} position={position} onClose={onClose} onFinishedHiding={this.handleFinishedHiding}>
        {children}
      </PopoverContent>);
    }
    render() {
        const { visible } = this.props;
        const { hiding } = this.state;
        const { showPopover } = this.context;
        if (visible || hiding) {
            return showPopover(this.renderPopover());
        }
        return null;
    }
}
Popover.contextTypes = {
    showPopover: Function,
};
Popover.defaultProps = {
    anchorId: '',
    position: 'left',
    offsetTop: 0,
    contentWrapperClassName: '',
    isCloseButton: false,
    isHoverPopover: false,
    visible: false,
    hasLockedPosition: false,
};
Popover.Provider = PopoverProvider;
